import { Link } from "react-router-dom";

export default function Footer({ scrollToSection }) {
  return (
    <div
      className={`bg-myNeutral26 w-full md:h-dvh flex flex-col justify-center max-md:pb-10`}
      id="footer"
    >
      <div
        className={`myContainer max-md:px-4 flex max-md:flex-col justify-evenly max-md:items-center py-10 md:py-[75px] overflow-hidden relative`}
      >
        <div className={`flex flex-col`}>
          <div className={`max-md:flex max-md:justify-center`}>
            <img
              src="/img/home/footerLogo.png"
              alt="Footer Logo"
              className={`max-w-[166px]`}
            />
          </div>
          <p
            className={`text-white md:max-w-[280px] mt-6 text-justify md:text-right`}
          >
            ما در خانوادۀ G&G تلاش می‌کنیم در کنار هم و در یک محیط جذاب و
            رقابتی، هم خودمون رشد کنیم، هم باعث رشد جامعه‌مون بشیم، و هم حال
            زمین رو بهتر کنیم.
          </p>
          <div className={`flex items-center gap-2 mt-12`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12Z"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M6 8L8.1589 9.79908C9.99553 11.3296 10.9139 12.0949 12 12.0949C13.0861 12.0949 14.0045 11.3296 15.8411 9.79908L18 8"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            <a
              href="mailto:info@gameandgrow.com"
              className={`text-white font-medium`}
            >
              info@gameandgrow.com
            </a>
          </div>
          <div
            className={`flex md:items-center max-md:flex-col gap-4 md:gap-8 mt-6`}
          >
            <svg
              className={`max-md:hidden`}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M13.9624 5.81617L13.3134 6.9791C12.7277 8.02858 12.9628 9.40532 13.8853 10.3278C13.8853 10.3278 13.8853 10.3278 13.8853 10.3278C13.8854 10.3279 15.0041 11.4468 12.9755 13.4755C10.9475 15.5035 9.82861 14.3861 9.8278 14.3853C9.82778 14.3853 9.82779 14.3853 9.82777 14.3853C8.90529 13.4628 7.52857 13.2277 6.4791 13.8134L5.31617 14.4624C3.73144 15.3468 3.54428 17.5692 4.93723 18.9622C5.77423 19.7992 6.7996 20.4505 7.93309 20.4934C9.84122 20.5658 13.0817 20.0829 16.3323 16.8323C19.5829 13.5817 20.0658 10.3412 19.9934 8.43309C19.9505 7.2996 19.2992 6.27423 18.4622 5.43723C17.0692 4.04428 14.8468 4.23144 13.9624 5.81617Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            <a href="tel:+989360338896" className={`text-white font-medium`}>
              اشتراک پلتفرم سازمانی: <br /> ۰۹۹۶۰۳۳۸۸۹۶
            </a>
            <a href="tel:+989367503570" className={`text-white font-medium`}>
              ارتباط با شهروندان: <br /> 09367503570
            </a>
            <a href="tel:+989364975180" className={`text-white font-medium`}>
              ارتباط با سمن‌ها: <br /> 09364975180
            </a>
          </div>
          <div className={`flex items-center gap-2 mt-6`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 10.1433C4 5.64588 7.58172 2 12 2C16.4183 2 20 5.64588 20 10.1433C20 14.6055 17.4467 19.8124 13.4629 21.6744C12.5343 22.1085 11.4657 22.1085 10.5371 21.6744C6.55332 19.8124 4 14.6055 4 10.1433Z"
                stroke="white"
                strokeWidth="1.5"
              />
              <circle cx="12" cy="10" r="3" stroke="white" strokeWidth="1.5" />
            </svg>
            <span className={`text-white font-medium text-right`}>
              مشهد - بلوار ملک‌آباد - قدس 1 - پلاک 60 - مرکز نوآوری مریم
            </span>
          </div>
        </div>
        <div className={`flex flex-col gap-6 max-md:mt-14`}>
          <span className={`text-white text-lg`}> صفحات اجتماعی G&G</span>
          <div className={`flex items-center gap-7 md:gap-6`}>
            <Link
              to={`https://www.instagram.com/game.and.grow?igsh=MXdqd2FsY3dqamRrZw`}
              className={`size-14 md:size-10 flex justify-center items-center bg-[#34A85336] rounded-lg`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_3528_13304)">
                  <path
                    d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z"
                    fill="white"
                  />
                  <path
                    d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z"
                    fill="white"
                  />
                  <path
                    d="M19.8469 5.59214C19.8469 6.38902 19.2 7.0312 18.4078 7.0312C17.6109 7.0312 16.9688 6.38433 16.9688 5.59214C16.9688 4.79526 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.79995 19.8469 5.59214Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3528_13304">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Link>
            <Link
              to={`https://t.me/gameandgrow_support`}
              className={`size-14 md:size-10 flex justify-center items-center bg-[#34A85336] rounded-lg`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_3528_13299)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.43 8.85893C11.2628 9.3444 8.93014 10.3492 5.43189 11.8733C4.86383 12.0992 4.56626 12.3202 4.53917 12.5363C4.49339 12.9015 4.95071 13.0453 5.57347 13.2411C5.65818 13.2678 5.74595 13.2954 5.83594 13.3246C6.44864 13.5238 7.27283 13.7568 7.70129 13.766C8.08994 13.7744 8.52373 13.6142 9.00264 13.2853C12.2712 11.079 13.9584 9.96381 14.0643 9.93977C14.139 9.92281 14.2426 9.90148 14.3128 9.96385C14.3829 10.0262 14.376 10.1443 14.3686 10.176C14.3233 10.3691 12.5281 12.0381 11.5991 12.9018C11.3095 13.171 11.1041 13.362 11.0621 13.4056C10.968 13.5033 10.8721 13.5958 10.78 13.6846C10.2108 14.2333 9.78391 14.6448 10.8036 15.3168C11.2936 15.6397 11.6858 15.9067 12.077 16.1731C12.5042 16.4641 12.9303 16.7543 13.4816 17.1157C13.6221 17.2077 13.7562 17.3034 13.8869 17.3965C14.3841 17.751 14.8307 18.0694 15.3826 18.0186C15.7032 17.9891 16.0345 17.6876 16.2027 16.7884C16.6002 14.6631 17.3816 10.0585 17.5622 8.16097C17.578 7.99473 17.5581 7.78197 17.5422 7.68857C17.5262 7.59518 17.4928 7.46211 17.3714 7.3636C17.2276 7.24694 17.0056 7.22234 16.9064 7.22408C16.455 7.23203 15.7626 7.47282 12.43 8.85893Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3528_13299">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Link>
            <Link
              to={`https://www.linkedin.com/in/game-and-grow-startup-989440307/`}
              className={`size-14 md:size-10 flex justify-center items-center bg-[#34A85336] rounded-lg`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_3528_13297)">
                  <path
                    d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5562 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3528_13297">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Link>
          </div>
          <div className={`flex items-center gap-3`}>
            <a
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=645298&Code=lvg8m5FGHOqnndX5o7dEIH4BlAlhcsD7"
            >
              <img
                referrerPolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=645298&Code=lvg8m5FGHOqnndX5o7dEIH4BlAlhcsD7"
                alt=""
                style={{ cursor: "pointer" }}
                code="lvg8m5FGHOqnndX5o7dEIH4BlAlhcsD7"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Absolute Divs */}
      {window?.location?.pathname === "/" && (
        <>
          <div
            onClick={() => scrollToSection(0)}
            className={`border-l-[6px] border-white border-t-[6px] absolute -right-2 bottom-[74px] rounded-tl-[48px] p-5 cursor-pointer max-md:hidden`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20 33.3334L20 6.66675M20 6.66675L30 16.6667M20 6.66675L10 16.6667"
                stroke="#22BA83"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`py-8 md:py-6 flex justify-center items-center myContainer absolute bottom-0 border-t border-[#22BA83] bg-[#3A3A3A]`}
          >
            <span className={`text-white font-medium tracking-tighter`}>
              Copyright © 2024 - 2025 G&G All Rights Reserved
            </span>
          </div>
        </>
      )}
    </div>
  );
}
